import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { ITwoOptionModal } from '../../interfaces/components';

@Component({
  selector: 'app-two-option-modal',
  templateUrl: './two-option-modal.component.html',
  styleUrls: ['./two-option-modal.component.scss']
})
export class TwoOptionModalComponent {

  public option: ITwoOptionModal;
  public emailLogin: string;

  constructor(
    public activeModal: NgbActiveModal
  ) { 
    this.emailLogin = environment.emailLogin;
  }

}
